'use client';

import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { useState } from 'react';
import classNames from 'classnames';
import { GetPageComponentViewModel } from '@/types/cml-api';
import { autoSwitch } from '@/features/carousel/plugins';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import Arrow from './arrow';
import CarouselBigItem from './carousel-big-item';
import Dots from './dots';
import Skeleton from './skeleton';
import { deviceTypeClassGenerator } from '../../_utils/device-type-handlers';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
}
export function CarouselBig({
  data,
  isLazy
}: Props) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(PUBLIC_IS_BOT);
  const hasSingleItem = data.items?.length === 1;
  const origin = 'center';
  const [sliderRef, instanceRef] = useKeenSlider<HTMLElement>({
    initial: 0,
    rtl: data.items?.length && data.items?.length > 2 ? true : false,
    loop: !hasSingleItem,
    slides: {
      perView: 1.2,
      spacing: 16,
      origin
    },
    breakpoints: {
      '(min-width: 992px)': {
        slides: {
          perView: 1.1,
          spacing: 24,
          origin
        }
      }
    },
    ...(hasSingleItem ? {} : {
      defaultAnimation: {
        duration: 2500
      }
    }),
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    }
  }, [autoSwitch]);
  const carouselItems = data.items?.map((item, index) => <CarouselBigItem key={item.id || item.link} item={item} currentSlide={currentSlide} slideIndex={index} isLazy={isLazy || index !== 0} sortKey={data?.sortKey} componentId={data?.id} />);
  return <div className={`group relative h-[calc(100vw/1.2-2.5px)] min-h-[300px] md:h-[calc((90vw/71)*24-2.5px)] lg:min-h-[460px]`} data-sentry-component="CarouselBig" data-sentry-source-file="carousel-big.tsx">
            <div ref={sliderRef} id={data.id || ''} className={classNames('keen-slider', deviceTypeClassGenerator(data.deviceTypes || ''), {
      invisible: !loaded
    })}>
                {carouselItems}
                {!hasSingleItem && loaded && instanceRef.current && <>
                        <div className={classNames('absolute bottom-4 right-[6.25%] z-10 flex items-center gap-3 opacity-0 transition-opacity duration-200 lg:group-hover:opacity-100')}>
                            <Arrow direction='right' onClick={e => {
            e.stopPropagation();
            instanceRef.current?.prev();
          }} />
                            <Arrow direction='left' onClick={e => {
            e.stopPropagation();
            instanceRef.current?.next();
          }} />
                        </div>
                        <Dots instanceRef={instanceRef} currentSlide={currentSlide} />
                    </>}
            </div>
            {!loaded && <Skeleton />}
        </div>;
}